import { render } from "./ErfolgeNeuView.vue?vue&type=template&id=2b3e6278&scoped=true"
import script from "./ErfolgeNeuView.vue?vue&type=script&lang=js"
export * from "./ErfolgeNeuView.vue?vue&type=script&lang=js"

import "./ErfolgeNeuView.vue?vue&type=style&index=0&id=2b3e6278&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b3e6278"]])

export default __exports__